import { Flex } from '@radix-ui/themes';
import logo from '../img/logo.svg';
import './Footer.css';

export default function Footer() {
  const gitCommit = process.env.REACT_APP_GIT_COMMIT || 'unknown';

  return (
    <div className="footer-wrap">
      <Flex className="link-list" align="center" justify="center" direction={{ initial: 'column', sm: 'row' }}>
        <a 
          className="footer-logo"
          href="https://ama-assn.org/"
          title="JAMA Network Home"
        >
          <img 
            style={{ height: '38px' }} 
            src={logo} 
            alt="Ed Hub logo" />
        </a>
        <a 
          href="https://ama-assn.org/about/code-conduct" 
          title="View the AMA Code of Conduct and Anti-harassment policy."
        >Code of Conduct</a>
        <a 
          href="https://ama-assn.org/about/terms-use" 
          title="Read the Terms of Use for accessing and using any AMA website or online property. If you do not agree to the Terms, please exit the AMA website."
        >Terms of Use</a>
        <a 
          href="https://ama-assn.org/about/privacy-policy" 
          title="The American Medical Association (AMA) respects your privacy and is committed to protecting it at all times."
        >Privacy Policy</a>
        <a 
          href="https://ama-assn.org/about/accessibility-statement" 
          title="Read about the American Medical Association's commitment to providing a website that is accessible to all users, including those with disabilities."
        >Website Accessibility</a>
        <a 
          href="https://cdn.rcrsv.io/five9/americanmedicalassociation/index.html" 
          title="Share your screen with a live AMA support agent"
        >Share Your Screen</a>
      </Flex>
      <div className="copyright">
        <span>© 2026 American Medical Association. All rights reserved, including those for text and data mining, AI training, and similar technologies.</span>
      </div>
      <div style={{
        position: 'absolute',
        left: '0',
        bottom: '0',
        fontSize: '10px',
        overflow: 'hidden',
      }} data-git-commit={gitCommit}>
        v{gitCommit}
      </div>
    </div>
  )
}
